export default __webpack_public_path__ + "static/media/stay-clear.e45e519a.svg";